/* Launch theme — storefront scripts (no dependencies) */
(() => {
  'use strict';
  const theme = window.theme || (window.theme = {});
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

  /* ---------- Money ---------- */
  theme.formatMoney = (cents, format = theme.moneyFormat || '${{amount}}') => {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const value = Number(cents) || 0;
    const fmt = (n, decimals, thousands = ',', decimal = '.') => {
      const fixed = (n / 100).toFixed(decimals);
      const [int, dec] = fixed.split('.');
      return int.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (dec ? decimal + dec : '');
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_no_decimals': return fmt(value, 0);
        case 'amount_with_comma_separator': return fmt(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(value, 0, '.', ',');
        case 'amount_with_space_separator': return fmt(value, 2, ' ', ',');
        case 'amount_with_apostrophe_separator': return fmt(value, 2, "'", '.');
        default: return fmt(value, 2);
      }
    });
  };

  /* ---------- Body scroll lock for drawers ---------- */
  const lockScroll = (on) => { document.documentElement.style.overflow = on ? 'hidden' : ''; };

  /* ---------- Menu drawer ---------- */
  const initMenu = () => {
    const drawer = $('[data-menu-drawer]');
    if (!drawer) return;
    const toggle = $('[data-menu-open]');
    const open = () => { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); toggle && toggle.setAttribute('aria-expanded', 'true'); lockScroll(true); };
    const close = () => { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); toggle && toggle.setAttribute('aria-expanded', 'false'); lockScroll(false); };
    toggle && toggle.addEventListener('click', open);
    $$('[data-menu-close]', drawer).forEach((el) => el.addEventListener('click', close));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
  };

  /* ---------- Announcement rotator + countdown ---------- */
  const initAnnouncement = () => {
    $$('[data-rotator]').forEach((rot) => {
      const items = $$('.announcement__item', rot);
      if (items.length < 2) return;
      let i = 0;
      setInterval(() => {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, Number(rot.dataset.interval) || 4000);
    });

    const timers = $$('[data-countdown]');
    if (!timers.length) return;
    const pad = (n) => String(n).padStart(2, '0');
    const tick = () => {
      timers.forEach((el) => {
        const end = new Date(el.dataset.countdown).getTime();
        let diff = Math.max(0, end - Date.now());
        if (diff === 0 && el.dataset.countdownHide === 'true') {
          const item = el.closest('.announcement__item');
          if (item) item.hidden = true;
          return;
        }
        const d = Math.floor(diff / 864e5); diff -= d * 864e5;
        const h = Math.floor(diff / 36e5); diff -= h * 36e5;
        const m = Math.floor(diff / 6e4); diff -= m * 6e4;
        const s = Math.floor(diff / 1e3);
        el.textContent = (d > 0 ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
      });
    };
    tick();
    setInterval(tick, 1000);
  };

  /* ---------- Campaign bar countdown (real end date) ---------- */
  const initCampaign = () => {
    $$('[data-campaign]').forEach((bar) => {
      if (bar.dataset.bound) return;
      bar.dataset.bound = '1';
      const end = new Date(bar.dataset.end).getTime();
      const timer = $('[data-campaign-timer]', bar);
      if (!timer || isNaN(end)) return;
      const pad = (n) => String(n).padStart(2, '0');
      const finish = () => {
        if (bar.dataset.after === 'message' && $('[data-campaign-after]', bar)) {
          $('[data-campaign-live]', bar).hidden = true;
          $('[data-campaign-after]', bar).hidden = false;
          timer.hidden = true;
        } else {
          bar.hidden = true;
        }
      };
      let id;
      const tick = () => {
        let diff = end - Date.now();
        if (diff <= 0) { clearInterval(id); finish(); return; }
        const d = Math.floor(diff / 864e5); diff -= d * 864e5;
        const h = Math.floor(diff / 36e5); diff -= h * 36e5;
        const m = Math.floor(diff / 6e4); diff -= m * 6e4;
        const s = Math.floor(diff / 1e3);
        $$('[data-unit="d"]', timer).forEach((el) => { el.hidden = d === 0; });
        $('[data-v="d"]', timer).textContent = pad(d);
        $('[data-v="h"]', timer).textContent = pad(h);
        $('[data-v="m"]', timer).textContent = pad(m);
        $('[data-v="s"]', timer).textContent = pad(s);
      };
      tick();
      id = setInterval(tick, 1000);
    });
  };

  /* ---------- Autoplay videos when visible ---------- */
  const initAutoplay = () => {
    const vids = $$('video.js-autoplay, .js-autoplay video');
    if (!vids.length) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    vids.forEach((v) => { v.muted = true; v.playsInline = true; v.setAttribute('playsinline', ''); });
    if (reduce || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach(({ target, isIntersecting }) => {
        if (isIntersecting) { target.preload = 'auto'; target.play().catch(() => {}); }
        else target.pause();
      });
    }, { threshold: 0.35 });
    vids.forEach((v) => io.observe(v));
    const pio = new IntersectionObserver((entries) => {
      entries.forEach(({ target, isIntersecting }) => {
        if (isIntersecting && target.dataset.poster) { target.poster = target.dataset.poster; delete target.dataset.poster; pio.unobserve(target); }
      });
    }, { rootMargin: '300px' });
    vids.forEach((v) => { if (v.poster && v.getBoundingClientRect().top > window.innerHeight) { v.dataset.poster = v.poster; v.removeAttribute('poster'); pio.observe(v); } });
  };

  /* ---------- Video reel (scroll + mute) ---------- */
  const initReels = () => {
    $$('[data-reel-section]').forEach((sec) => {
      const reel = $('[data-reel]', sec);
      if (!reel) return;
      const step = () => (reel.firstElementChild ? reel.firstElementChild.getBoundingClientRect().width + 14 : 300);
      const prev = $('[data-reel-prev]', sec);
      const next = $('[data-reel-next]', sec);
      prev && prev.addEventListener('click', () => reel.scrollBy({ left: -step(), behavior: 'smooth' }));
      next && next.addEventListener('click', () => reel.scrollBy({ left: step(), behavior: 'smooth' }));
      $$('[data-reel-mute]', sec).forEach((btn) => {
        btn.addEventListener('click', () => {
          const video = btn.parentElement.querySelector('video');
          if (!video) return;
          const willUnmute = video.muted;
          $$('video', sec).forEach((v) => { v.muted = true; });
          $$('[data-reel-mute]', sec).forEach((b) => b.setAttribute('aria-label', 'Unmute'));
          $$('[data-muted-icon]', sec).forEach((p) => (p.style.display = ''));
          if (willUnmute) {
            video.muted = false;
            video.play().catch(() => {});
            btn.setAttribute('aria-label', 'Mute');
            const icon = btn.querySelector('[data-muted-icon]');
            if (icon) icon.style.display = 'none';
          }
        });
      });
    });
  };

  /* ---------- Before / after ---------- */
  const initBeforeAfter = () => {
    $$('[data-ba]').forEach((ba) => {
      const range = $('[data-ba-range]', ba);
      if (!range) return;
      const set = () => ba.style.setProperty('--pos', range.value + '%');
      range.addEventListener('input', set);
      set();
    });
  };

  /* ---------- Quantity steppers ---------- */
  const initQty = (ctx = document) => {
    $$('[data-qty]', ctx).forEach((wrap) => {
      if (wrap.dataset.bound) return;
      const input = $('input', wrap);
      if (!input || !$('[data-qty-minus]', wrap) || !$('[data-qty-plus]', wrap)) return;
      wrap.dataset.bound = '1';
      $('[data-qty-minus]', wrap).addEventListener('click', () => { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); input.dispatchEvent(new Event('change', { bubbles: true })); });
      $('[data-qty-plus]', wrap).addEventListener('click', () => { input.value = (parseInt(input.value, 10) || 1) + 1; input.dispatchEvent(new Event('change', { bubbles: true })); });
    });
  };

  /* ---------- Delivery estimate ---------- */
  const initDelivery = () => {
    $$('[data-delivery]').forEach((el) => {
      const addBusinessDays = (date, days) => {
        const d = new Date(date);
        let added = 0;
        while (added < days) {
          d.setDate(d.getDate() + 1);
          const day = d.getDay();
          if (day !== 0 && day !== 6) added++;
        }
        return d;
      };
      const loc = el.dataset.locale || document.documentElement.lang || undefined;
      const fmt = (d) => { try { return d.toLocaleDateString(loc, { weekday: 'short', month: 'short', day: 'numeric' }); } catch (e) { return d.toLocaleDateString(); } };
      const now = new Date();
      const from = addBusinessDays(now, Number(el.dataset.min) || 5);
      const to = addBusinessDays(now, Number(el.dataset.max) || 9);
      const text = $('[data-delivery-text]', el);
      if (text && el.dataset.template) text.innerHTML = el.dataset.template.replace('[from]', fmt(from)).replace('[to]', fmt(to));

      const cutoffEl = $('[data-delivery-cutoff]', el);
      if (!cutoffEl || el.dataset.showCutoff !== 'true') return;
      const cutoffHour = Number(el.dataset.cutoff);
      const update = () => {
        const n = new Date();
        const cutoff = new Date(n); cutoff.setHours(cutoffHour, 0, 0, 0);
        const weekend = n.getDay() === 0 || n.getDay() === 6;
        if (weekend || n >= cutoff) { cutoffEl.hidden = true; return; }
        const diff = cutoff - n;
        const h = Math.floor(diff / 36e5);
        const m = Math.floor((diff % 36e5) / 6e4);
        cutoffEl.hidden = false;
        cutoffEl.innerHTML = el.dataset.cutoffTemplate.replace('[time]', `${h}h ${String(m).padStart(2, '0')}m`);
      };
      update();
      setInterval(update, 30000);
    });
  };

  /* ---------- Cart ---------- */
  const cart = {
    drawer: null,
    async fetch() { const r = await fetch(theme.routes.cartJs, { headers: { Accept: 'application/json' } }); return r.json(); },
    async add(items) {
      const r = await fetch(theme.routes.cartAdd, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items })
      });
      const data = await r.json();
      if (!r.ok) throw new Error(data.description || data.message || 'Could not add to cart');
      return data;
    },
    async change(line, quantity) {
      const r = await fetch(theme.routes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity })
      });
      return r.json();
    },
    updateBubble(count) {
      $$('[data-cart-bubble]').forEach((b) => { b.dataset.count = count; b.textContent = count > 0 ? count : ''; });
      $$('[data-cart-count]').forEach((b) => { b.textContent = count; });
    },
    render(data) {
      this.updateBubble(data.item_count);
      const drawer = this.drawer;
      if (!drawer) return;
      const list = $('[data-cart-items]', drawer);
      const total = $('[data-cart-total]', drawer);
      if (total) total.textContent = theme.formatMoney(data.total_price);
      const savings = $('[data-cart-savings]', drawer);
      if (savings) {
        const saved = Number(data.total_discount) || 0;
        savings.hidden = saved <= 0;
        if (saved > 0) $('[data-cart-savings-amount]', savings).textContent = '−' + theme.formatMoney(saved);
      }

      const threshold = Number(theme.freeShippingThreshold) || 0;
      const prog = $('[data-ship-progress]', drawer);
      if (prog && threshold > 0) {
        const left = Math.max(0, threshold - data.total_price);
        $('[data-ship-progress-text]', prog).textContent = left === 0
          ? theme.strings.freeShippingUnlocked
          : theme.strings.freeShippingAway.replace('[amount]', theme.formatMoney(left));
        $('[data-ship-progress-bar]', prog).style.width = Math.min(100, (data.total_price / threshold) * 100) + '%';
      }

      const up = $('[data-cart-upsell]', drawer);
      if (up) {
        const vid = Number(up.dataset.variantId);
        up.hidden = !data.items.length || data.items.some((it) => it.variant_id === vid);
      }

      const banner = $('[data-cart-banner]', drawer);
      if (banner) banner.hidden = !data.items.length;
      if (!data.items.length) {
        list.innerHTML = `<div class="drawer__empty"><p>${theme.strings.cartEmpty}</p><button type="button" class="button button--secondary" data-drawer-close>${theme.strings.continueShopping || ''}</button></div>`;
        const btn = $('[data-drawer-close]', list);
        if (btn) btn.addEventListener('click', () => this.close());
        $('.drawer__foot', drawer).hidden = true;
        return;
      }
      $('.drawer__foot', drawer).hidden = false;
      list.innerHTML = data.items.map((item, i) => {
        const img = item.image ? item.image + (item.image.includes('?') ? '&' : '?') + 'width=200' : '';
        const variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
        const props = item.properties ? Object.entries(item.properties).filter(([k, v]) => v && !k.startsWith('_')).map(([k, v]) => `${k}: ${v}`).join(' · ') : '';
        const discounts = (item.line_level_discount_allocations || []).map((d) => d.discount_application && d.discount_application.title).filter(Boolean).join(', ');
        const compare = item.original_line_price > item.final_line_price ? `<s>${theme.formatMoney(item.original_line_price)}</s>` : '';
        return `
          <div class="cart-line">
            ${img ? `<img class="cart-line__img" src="${img}" alt="" loading="lazy" width="76" height="76">` : '<span class="cart-line__img"></span>'}
            <div>
              <a class="cart-line__title" href="${item.url}">${item.product_title}</a>
              ${variant || props || discounts ? `<p class="cart-line__variant">${[variant, props, discounts].filter(Boolean).join(' · ')}</p>` : ''}
              <div class="qty" data-line="${i + 1}">
                <button type="button" data-line-minus aria-label="-">${minusSvg}</button>
                <input type="number" value="${item.quantity}" min="0" aria-label="Quantity" data-line-input>
                <button type="button" data-line-plus aria-label="+">${plusSvg}</button>
              </div>
              <button type="button" class="cart-line__remove" data-line-remove="${i + 1}">${theme.strings.remove}</button>
            </div>
            <div class="cart-line__price">${compare}${theme.formatMoney(item.final_line_price)}</div>
          </div>`;
      }).join('');
    },
    async refresh() { const data = await this.fetch(); this.render(data); return data; },
    open() {
      if (!this.drawer) { window.location.href = theme.routes.cart; return; }
      this.drawer.classList.add('is-open');
      this.drawer.setAttribute('aria-hidden', 'false');
      lockScroll(true);
      const panel = $('.drawer__panel', this.drawer);
      panel && panel.focus();
    },
    close() {
      if (!this.drawer) return;
      this.drawer.classList.remove('is-open');
      this.drawer.setAttribute('aria-hidden', 'true');
      lockScroll(false);
    },
    init() {
      this.drawer = $('#CartDrawer');
      const self = this;
      const upForm = this.drawer && $('[data-cart-upsell-form]', this.drawer);
      if (upForm) upForm.addEventListener('submit', async (e) => {
        e.preventDefault();
        const btn = $('button[type="submit"]', upForm);
        if (btn) btn.disabled = true;
        try { await self.add([{ id: Number(upForm.elements.id.value), quantity: 1 }]); await self.refresh(); }
        catch (err) { upForm.submit(); }
        finally { if (btn) btn.disabled = false; }
      });
      $$('[data-cart-open]').forEach((a) => a.addEventListener('click', (e) => {
        if (!self.drawer) return;
        e.preventDefault();
        self.refresh().then(() => self.open());
      }));
      if (!this.drawer) return;
      $$('[data-drawer-close]', this.drawer).forEach((el) => el.addEventListener('click', () => self.close()));
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') self.close(); });

      this.drawer.addEventListener('click', async (e) => {
        const remove = e.target.closest('[data-line-remove]');
        const minus = e.target.closest('[data-line-minus]');
        const plus = e.target.closest('[data-line-plus]');
        if (!remove && !minus && !plus) return;
        let line, qty;
        if (remove) { line = Number(remove.dataset.lineRemove); qty = 0; }
        else {
          const wrap = e.target.closest('[data-line]');
          line = Number(wrap.dataset.line);
          const current = Number($('input', wrap).value) || 0;
          qty = plus ? current + 1 : Math.max(0, current - 1);
        }
        self.drawer.classList.add('is-busy');
        const data = await self.change(line, qty);
        self.render(data);
        self.drawer.classList.remove('is-busy');
      });
      this.drawer.addEventListener('change', async (e) => {
        if (!e.target.matches('[data-line-input]')) return;
        const wrap = e.target.closest('[data-line]');
        const data = await self.change(Number(wrap.dataset.line), Math.max(0, Number(e.target.value) || 0));
        self.render(data);
      });

      // Let apps (bundles, upsells) refresh and open the drawer.
      document.addEventListener('cart:refresh', () => self.refresh());
      document.addEventListener('cart:open', () => self.refresh().then(() => self.open()));
      this.refresh();
    }
  };
  const minusSvg = '<svg class="icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M5 12h14"/></svg>';
  const plusSvg = '<svg class="icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>';
  theme.cart = cart;
  window.openCartDrawer = () => cart.refresh().then(() => cart.open());

  /* ---------- Product ---------- */
  const initProduct = (section) => {
    const jsonEl = $('[data-product-json]', section);
    if (!jsonEl) return;
    const product = JSON.parse(jsonEl.textContent);
    const form = $('[data-product-form]', section);
    const idInput = form ? $('[data-variant-id]', form) : null;
    const atc = $('[data-atc]', section);
    const atcText = $('[data-atc-text]', section);
    const atcDefault = atcText ? atcText.textContent.trim() : theme.strings.addToCart;
    const picker = $('[data-variant-picker]', section);
    const sticky = $('[data-sticky-atc]', section);

    /* Gallery */
    const gallery = $('[data-gallery]', section);
    const track = gallery && $('[data-gallery-track]', gallery);
    const slides = track ? Array.from(track.children) : [];
    const counter = gallery && $('[data-gallery-counter]', gallery);
    const thumbs = gallery ? $$('[data-thumb-index]', gallery) : [];
    const isGridDesktop = () => gallery.classList.contains('gallery--grid') && window.matchMedia('(min-width: 990px)').matches;
    const goTo = (index, smooth = true) => {
      if (!track || !slides[index]) return;
      if (isGridDesktop()) {
        slides[index].scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'center' });
        return;
      }
      track.scrollTo({ left: slides[index].offsetLeft - track.offsetLeft - (parseFloat(getComputedStyle(track).paddingLeft) || 0), behavior: smooth ? 'smooth' : 'auto' });
    };
    let current = 0;
    const setActive = (i) => {
      current = i;
      if (counter) counter.textContent = `${i + 1} / ${slides.length}`;
      thumbs.forEach((t, ti) => t.setAttribute('aria-current', ti === i ? 'true' : 'false'));
      const thumb = thumbs[i];
      if (thumb && thumb.parentElement) {
        const p = thumb.parentElement;
        const left = thumb.offsetLeft - p.offsetLeft - p.clientWidth / 2 + thumb.clientWidth / 2;
        p.scrollTo({ left, behavior: 'smooth' });
      }
    };
    if (track && slides.length > 1) {
      let raf;
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const w = slides[0].getBoundingClientRect().width || 1;
          const i = Math.round(track.scrollLeft / (w + 8));
          if (i !== current) setActive(Math.min(slides.length - 1, Math.max(0, i)));
        });
      }, { passive: true });
      thumbs.forEach((t) => t.addEventListener('click', () => { const i = Number(t.dataset.thumbIndex); goTo(i); setActive(i); }));
      const prev = $('[data-gallery-prev]', gallery);
      const next = $('[data-gallery-next]', gallery);
      prev && prev.addEventListener('click', () => { const i = (current - 1 + slides.length) % slides.length; goTo(i); setActive(i); });
      next && next.addEventListener('click', () => { const i = (current + 1) % slides.length; goTo(i); setActive(i); });
    }

    /* Variants */
    const selectedOptions = () => {
      if (!picker) return null;
      return product.options.map((_, i) => {
        const checked = picker.querySelector(`input[data-option-index="${i}"]:checked`);
        if (checked) return checked.value;
        const select = picker.querySelector(`select[data-option-index="${i}"]`);
        return select ? select.value : null;
      });
    };
    const findVariant = (opts) => product.variants.find((v) => v.options.every((o, i) => o === opts[i]));

    const markAvailability = (opts) => {
      if (!picker) return;
      product.options.forEach((_, i) => {
        picker.querySelectorAll(`input[data-option-index="${i}"]`).forEach((input) => {
          const test = opts.slice(); test[i] = input.value;
          const v = findVariant(test);
          input.classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    };

    const updatePrice = (variant) => {
      $$('[data-price-wrapper]', section).forEach((wrap) => {
        const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        wrap.classList.toggle('price--on-sale', !!onSale);
        const p = $('[data-price]', wrap); if (p) p.textContent = theme.formatMoney(variant.price);
        const c = $('[data-compare-price]', wrap);
        if (c) { c.hidden = !onSale; if (onSale) c.textContent = theme.formatMoney(variant.compare_at_price); }
        const b = $('[data-price-badge]', wrap);
        if (b) {
          b.hidden = !onSale;
          if (onSale) {
            const pct = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
            b.textContent = (b.dataset.badgeTemplate || '-[pct]%').replace('[pct]', pct);
          }
        }
      });
      const sp = sticky && $('[data-sticky-price]', sticky);
      if (sp) sp.textContent = theme.formatMoney(variant.price);
      const sc = sticky && $('[data-sticky-compare]', sticky);
      if (sc) { const onSale = variant.compare_at_price > variant.price; sc.hidden = !onSale; if (onSale) sc.textContent = theme.formatMoney(variant.compare_at_price); }
    };

    const onVariantChange = () => {
      const opts = selectedOptions();
      if (!opts) return;
      opts.forEach((val, i) => { const label = $(`[data-option-selected="${i}"]`, section); if (label) label.textContent = val; });
      markAvailability(opts);
      const variant = findVariant(opts);
      if (!variant) {
        if (atc) atc.disabled = true;
        if (atcText) atcText.textContent = theme.strings.unavailable;
        return;
      }
      if (idInput) { idInput.value = variant.id; idInput.dispatchEvent(new Event('change', { bubbles: true })); }
      if (atc) atc.disabled = !variant.available;
      if (atcText) atcText.textContent = variant.available ? atcDefault : theme.strings.soldOut;
      const sb = sticky && $('[data-sticky-button]', sticky);
      if (sb) sb.disabled = !variant.available;
      updatePrice(variant);
      if (variant.featured_media) {
        const idx = slides.findIndex((s) => s.dataset.mediaId === String(variant.featured_media.id));
        if (idx > -1) { goTo(idx); setActive(idx); }
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
      section.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant } }));
    };
    /* Pack selector */
    const offers = $('[data-offers]', section);
    const offersQty = offers ? $('[data-offers-qty]', offers) : null;
    const renderCard = (card, variant) => {
      const input = $('input[type="radio"]', card);
      const qty = Number(input.dataset.offerQty) || 1;
      const disc = Number(input.dataset.discount) || 0;
      const selects = $$('[data-offer-variant]', card);
      let base = 0;
      let compare = 0;
      if (selects.length) {
        selects.forEach((sel) => {
          const opt = sel.options[sel.selectedIndex];
          const p = Number(opt.dataset.price) || 0;
          const c = Number(opt.dataset.compare) || 0;
          base += p;
          compare += c > p ? c : p;
        });
      } else if (variant) {
        base = variant.price * qty;
        compare = (variant.compare_at_price && variant.compare_at_price > variant.price ? variant.compare_at_price : variant.price) * qty;
      } else return;
      const total = input.dataset.fixed ? Number(input.dataset.fixed) : Math.round(base * (100 - disc) / 100);
      $('[data-offer-total]', card).textContent = theme.formatMoney(total);
      const strike = $('[data-offer-compare]', card);
      strike.hidden = !(compare > total);
      strike.textContent = theme.formatMoney(compare);
    };
    const renderOffers = (variant) => {
      if (!offers) return;
      $$('.offer', offers).forEach((card) => renderCard(card, variant));
    };
    const currentVariant = () => {
      const id = idInput ? Number(idInput.value) : null;
      return product.variants.find((v) => v.id === id) || product.variants[0];
    };
    if (offers) {
      offers.addEventListener('change', (e) => {
        if (e.target.matches('[data-offer-variant]')) {
          renderCard(e.target.closest('.offer'), currentVariant());
          return;
        }
        if (!e.target.matches('input[type="radio"]')) return;
        $$('.offer', offers).forEach((c) => c.classList.toggle('is-selected', $('input[type="radio"]', c).checked));
        if (offersQty) offersQty.value = e.target.dataset.offerQty;
      });
      section.addEventListener('variant:change', (e) => {
        const v = e.detail.variant;
        $$('[data-offer-variant]', offers).forEach((sel) => {
          const opt = Array.from(sel.options).find((o) => Number(o.value) === v.id);
          if (opt && !opt.disabled) sel.value = String(v.id);
        });
        renderOffers(v);
      });
    }

    if (picker) {
      picker.addEventListener('change', onVariantChange);
      markAvailability(selectedOptions());
    }

    /* Add to cart */
    if (form && atc) {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const qtyInput = $('[data-offers-qty]', section) || document.getElementById(`Quantity-${section.dataset.section}`) || form.querySelector('[name="quantity"]');
        const qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
        const fd = new FormData(form);
        const properties = {};
        for (const [k, v] of fd.entries()) {
          const m = k.match(/^properties\[(.+)\]$/);
          if (m && v) properties[m[1]] = v;
        }
        const extra = {};
        if (Object.keys(properties).length) extra.properties = properties;
        if (fd.get('selling_plan')) extra.selling_plan = fd.get('selling_plan');
        let items = [{ id: Number(fd.get('id')), quantity: qty, ...extra }];
        const chosen = offers && $('.offer.is-selected', offers);
        const picks = chosen ? $$('[data-offer-variant]', chosen) : [];
        if (picks.length) {
          const counts = new Map();
          picks.forEach((sel) => counts.set(Number(sel.value), (counts.get(Number(sel.value)) || 0) + 1));
          items = Array.from(counts, ([id, quantity]) => ({ id, quantity, ...extra }));
        }

        atc.classList.add('is-loading');
        if (atcText) atcText.textContent = theme.strings.adding;
        try {
          await cart.add(items);
          if (theme.cartType === 'checkout') { window.location.href = '/checkout'; return; }
          if (theme.cartType === 'page' || !cart.drawer) { window.location.href = theme.routes.cart; return; }
          await cart.refresh();
          cart.open();
        } catch (err) {
          alert(err.message);
        } finally {
          atc.classList.remove('is-loading');
          if (atcText) atcText.textContent = atc.disabled ? theme.strings.soldOut : atcDefault;
        }
      });
    }

    /* Sticky ATC: show when buy buttons scroll out of view; hide near footer */
    if (sticky) {
      const target = $('[data-buy-buttons]', section) || $('.product__info', section);
      const footer = $('.footer');
      let targetGone = false;
      let footerVisible = false;
      const sync = () => {
        const show = targetGone && !footerVisible;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        const btn = $('[data-sticky-button]', sticky);
        if (btn) btn.tabIndex = show ? 0 : -1;
      };
      if ('IntersectionObserver' in window && target) {
        new IntersectionObserver(([entry]) => {
          targetGone = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          sync();
        }).observe(target);
        if (footer) new IntersectionObserver(([entry]) => { footerVisible = entry.isIntersecting; sync(); }).observe(footer);
      }
      const btn = $('[data-sticky-button]', sticky);
      btn && btn.addEventListener('click', () => {
        if (sticky.dataset.action === 'add' && form) {
          form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true }));
        } else {
          scrollToOffer(section);
        }
      });
    }
  };

  const scrollToOffer = (section = document) => {
    const anchor = $('[data-offers]', section) || $('.product__app', section) || $('[data-variant-picker]', section) || $('[data-buy-buttons]', section) || $('.product__info', section);
    if (!anchor) return false;
    const y = anchor.getBoundingClientRect().top + window.scrollY - 90;
    window.scrollTo({ top: y, behavior: 'smooth' });
    return true;
  };

  const initScrollLinks = () => {
    $$('[data-scroll-to-offer]').forEach((a) => {
      if (a.getAttribute('href') !== '#MainContent') return;
      a.addEventListener('click', (e) => {
        const sec = $('[data-product-section]');
        if (sec && scrollToOffer(sec)) e.preventDefault();
      });
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    initMenu();
    initAnnouncement();
    initCampaign();
    initAutoplay();
    initReels();
    initBeforeAfter();
    initQty();
    initDelivery();
    cart.init();
    $$('[data-product-section]').forEach(initProduct);
    initScrollLinks();
  });

  // Theme editor: re-init when sections reload.
  document.addEventListener('shopify:section:load', (e) => {
    initCampaign(); initAutoplay(); initReels(); initBeforeAfter(); initQty(e.target); initDelivery();
    $$('[data-product-section]', e.target).forEach(initProduct);
  });
})();
